/*  Site Terms of Use 2025 */
const SiteTerms = () => {
    return (
        <div className="my-4 text-sm text-gray-600">
            <section className="mb-6">
                <h2 className="mb-2">1. ACCEPTANCE OF TERMS</h2>
                <p>
                    Creating a MetEd account or using <a href="https://learn.meted.ucar.edu" className="text-blue-500" target="_blank" rel="noopener noreferrer">https://learn.meted.ucar.edu</a> (the "Site") means you accept these Terms of Use (the "Terms") and UCAR's master <a href="https://www.ucar.edu/privacy-notice" className="text-blue-500" target="_blank" rel="noopener noreferrer">Privacy Notice</a>.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="">2. PRIVACY & COOKIES</h2>
                <p>
                    We set only essential cookies plus an anonymous Google Analytics cookie if you click Allow all on the banner. You may change your choice at any time via the round icon in the lower‑right corner of the Site.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="">3. COPYRIGHT & PERMITTED USE</h2>
                <p className="mb-4">
                    This Site was developed by the COMET® Program of the University Corporation for Atmospheric Research (UCAR). The views expressed on the Site are those of the authors and do not necessarily reflect the views of the sponsors of COMET or UCAR.
                </p>
                <p className="mb-4">
                    Except where noted, all content is © 1997‑2025 UCAR and the COMET® Program. COMET® is a registered trademark of UCAR.
                </p>
                <p className="mb-4">
                    For these Terms, “Materials” means all images, information, documents, software, data, models, and services made available on or through the Site. Most Materials have been developed by COMET, but some are provided by COMET with permission from third parties (“Third‑Party Materials”). Your use of any Third‑Party Materials may be limited by additional terms of use required by the third party (“Additional Terms”). COMET routinely includes applicable third‑party credit and/or copyright notices next to the image itself or in a closely associated bibliography or image gallery. In the absence of specific terms of use, only these Terms apply.
                </p>
                <h3 className="mt-4">3.  Open‑Educational Materials</h3>
                <p>
                    You may copy, adapt, and redistribute Materials for non‑profit training, research, or educational purposes provided you:
                </p>
                <ul className="list-disc pl-6 mb-4">
                    <li>Do not misrepresent the content.</li>
                    <li className="mt-2">
                        Include this credit line (adapt as needed):<br />
                        <span className="block border-l-4 border-gray-300 pl-4 my-2 italic">
                            “Source: COMET® Website <a href="https://learn.meted.ucar.edu" className="text-blue-500" target="_blank" rel="noopener noreferrer">https://learn.meted.ucar.edu</a>. © 1997‑2025 University Corporation for  Atmospheric Research.”
                        </span>
                    </li>
                    <li>Respect any Additional Terms that accompany Third‑Party Materials.</li>
                    <li>Keep all credits and copyright notices intact and affixed to every reuse.</li>
                </ul>
                <p>
                    Any direct or indirect commercial use requires prior written permission from UCAR.
                </p>
                <p>
                    You are solely responsible for determining whether your intended use of any Material is permissible under these Terms or any Additional Terms.
                </p>
                {/*<h3 className="mt-4">3.B  Paid Content (MetEd Store)</h3>
                <p>
                    Purchases made through the MetEd Store are governed by the separate Store Terms &amp; Conditions (“Store Terms”), which you must accept at checkout. If these Terms conflict with the Store Terms, the Store Terms control for that product.
                </p>*/}
            </section>

            <section className="mb-6">
                <h2 className="">4.  ADDITIONAL LEGAL NOTICES</h2>
                <h3 className="mt-4">4.A  Third‑Party Platforms &amp; Service Providers</h3>
                <p>
                    The Site relies on a variety of third‑party platforms and vendors—including learning‑management, payment‑processing, cloud‑hosting, analytics, and video‑hosting services (collectively, “Service Providers”)—to operate and deliver content. UCAR may engage, replace, or remove Service Providers at its discretion.
                </p>
                <p>
                    By using the Site, you acknowledge that information you submit may be processed by these Service Providers under their own terms and privacy policies, and that such processing may occur outside of the United States. UCAR is not responsible for the acts, omissions, or privacy practices of any Service Provider.
                </p>
                <h3 className="mt-4">4.B  Third‑Party &amp; Embedded Content</h3>
                <p>
                    The Site may embed YouTube videos or link to external websites (“third‑party sites”). UCAR does not control third‑party cookies, content, or changes to those sites and is not responsible for any third‑party site or any linked content within it. No sponsorship, approval, or endorsement by UCAR is intended or implied.
                </p>
                <h3 className="mt-4">4.C  No Endorsement / Recommendation</h3>
                <p>
                    References to commercial products or services do not constitute endorsement or favoring by UCAR. The names UCAR or COMET may not be used in advertising or publicity without written permission from UCAR.
                </p>
                <h3 className="mt-4">4.D  No Support Obligation</h3>
                <p>
                    Unless separately agreed in writing, UCAR is not obligated to provide support, updates, or training for the Site or Materials. Nothing in this section limits support that UCAR may elect to provide to the employees or other authorized users of a UCAR‑sponsoring organization.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="">5.  NOTIFICATION OF COPYRIGHT INFRINGEMENT</h2>
                <p>
                    If you believe any content on the Site infringes your copyright, please follow UCAR’s <a href="https://www.ucar.edu/notification-copyright-infringement-digital-millenium-copyright-act" className="text-blue-500" target="_blank" rel="noopener noreferrer">Notification of Copyright Infringement – Digital Millennium Copyright Act procedure</a>.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="">6.  DISCLAIMER &amp; LIMITATION OF LIABILITY</h2>
                <p className="uppercase text-sm">
                    THE CONTENT ON THIS WEBSITE IS PROVIDED BY UCAR “AS IS,” AND UCAR EXPRESSLY DISCLAIMS THE APPLICABILITY OF THE UNIFORM COMPUTER INFORMATION TRANSACTIONS ACT (UCITA), AND ANY OTHER EXPRESS OR IMPLIED WARRANTIES, INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF NONINFRINGEMENT, MERCHANTABILITY, AND FITNESS FOR A PARTICULAR PURPOSE. IN NO EVENT SHALL UCAR BE LIABLE FOR ANY DAMAGES OF ANY NATURE ARISING OUT OF THE USE OF THIS SITE OR UCAR'S EXERCISE OF ITS RIGHTS UNDER THESE TERMS OF USE. UCAR SHALL NOT BE LIABLE FOR ANY SPECIAL, INDIRECT, PUNITIVE, OR CONSEQUENTIAL DAMAGES, OR ANY LOSS OR DAMAGES WHATSOEVER, INCLUDING, BUT NOT LIMITED TO, CLAIMS ASSOCIATED WITH THE LOSS OF DATA OR PROFITS, WHICH MAY RESULT FROM AN ACTION IN CONTRACT, TORT, OR IN EQUITY THAT ARISES OUT OF OR IN CONNECTION WITH THE ACCESS, USE, CONTENT, PERFORMANCE OF, OR RELIANCE ON THIS WEBSITE, ANY LINKED WEBSITE, OR ANY LINKS CONTAINED IN ANY LINKED WEBSITE.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="">7.  EXPORT COMPLIANCE</h2>
                <p>
                    You agree to comply with all applicable U.S. export‑control laws when using or sharing Materials.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="">8.  GOVERNING LAW</h2>
                <p>
                    These Terms are governed by the laws of the State of Colorado and the United States of America, without regard to conflict of law principles. Venue lies exclusively in Colorado courts.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="">9.  CHANGES</h2>
                <p>
                    We may revise these Terms at any time. The “Last updated” date will change on revision. Your continued use of the Site constitutes acceptance of the updated Terms.
                </p>
            </section>
        </div>
    );
};

export default SiteTerms;
